"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Accordion = require("grommet/es6/components/Accordion");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Accordion = function Accordion(props) {
  return (/*#__PURE__*/_react["default"].createElement(_Accordion.Accordion, props)
  );
};

var _default = Accordion;
exports["default"] = _default;